import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const FlashIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M1.90503 12.0001L8.79461 6.25879V9.78365H10.9658V14.2165H8.79461V15.9932V17.7414L1.90503 12.0001ZM4.46311 12.0001L7.15697 14.245V12.5788H9.32819V11.4213H7.15697V9.75523L4.46311 12.0001ZM22.0951 12.0001L15.2055 6.25879V9.78365H13.0343V14.2165H15.2055V15.9932V17.7414L22.0951 12.0001ZM19.537 12.0001L16.8432 14.245V12.5788H14.6719V11.4213H16.8432V9.75523L19.537 12.0001Z"
      />
    </SvgIcon>
  );
});
